import { getSearchParam } from "@/utils";
import { get_gallery_info } from "@/utils/get_gallery_info";
import { nanoid } from "nanoid";
declare global {
  interface Window {
    Ya: {
      adfoxCode: {
        create: (config: {
          ownerId: string;
          containerId: string;
          type?: string;
          platform?: string;
          params: Record<string, string>;
          lazyLoad?: {
            mobileScaling?: number;
            fetchMargin?: number;
          };
        }) => void;
      };
    };
    yaContextCb: Array<() => void>;
  }
}

interface Dex1Props {
  type?: string;
  ownerId: string;
  containerId: string;
  p1: string;
  p2: string;
  google_aid?: string;
  platform?: string;
  lazyLoad?: {
    mobileScaling?: number;
    fetchMargin?: number;
  };
}

export default (function Dex1(props: Dex1Props) {
  const {
    type = "dex",
    platform,
    ownerId,
    containerId,
    p1,
    p2,
    google_aid = get_gallery_info() || getSearchParam("gaid") || getSearchParam("client_info") || "",
    lazyLoad = {},
  } = props;

  const [isMounted, setIsMounted] = useState(false);
  const [containerId1, setContainerId1] = useState("");
  useEffect(() => {
    setIsMounted(true);
    setContainerId1(containerId + "_" + nanoid(3));
    return () => {
      setIsMounted(false);
    };
  }, []);
  useEffect(() => {
    if (!isMounted || !document.getElementById(containerId1)) return;
    // console.log("Dex1111", props, google_aid, lazyLoad, containerId1);
    window.yaContextCb = window.yaContextCb || [];
    window.yaContextCb.push(() => {
      window.Ya.adfoxCode.create({
        ownerId,
        containerId: containerId1,
        ...(type === "floorAd" && { type, platform }),
        ...(type === "dex" && !isEmptyType(lazyLoad) && { lazyLoad }),
        params: {
          p1,
          p2,
          google_aid,
        },
      });
    });
    // console.log("Ya.adfoxCode.create", { ownerId, containerId1, type, platform, p1, p2, google_aid });
  }, [isMounted, containerId1]);

  return <div id={containerId1}></div>;
});
